const data = {
  parents: [
    { name: 'Jerry Agnasin' },
    { name: 'Marilou Agnasin' },
    { name: 'Laremon Cardinal' },
    { name: 'Juana Cardinal' },
  ],
  primarySponsors: [
    { name: 'Romeo Calunsod' },
    { name: 'Atilano Millena Jr.' },
    { name: 'Arnolfo Moncada' },
    { name: 'Amador Trazo' },
    { name: 'Carlo Villafuerte' },

    { name: 'Bienvenida Calunsod' },
    { name: 'Febe Lazo Cadaing' },
    { name: 'Maria Theresa Agnasin Brooks' },
    { name: 'Victorina Ladringan' },
    { name: 'Erlinda Valdez Nalty' },
  ],
  bestman: {
    name: 'Jerry Agnasin II',
    desc: '',
    img: require('../../images/squadImg/jerry.jpg'),
    backgroundImg: require('../../images/squadBackgroundImg/jerry.jpg'),
    backgroundStyle: {
      top: '-7%',
      left: '-20%',
    },
  },
  maidOfHonor: {
    name: 'Angela Marie Calvo',
    desc: '',
    img: require('../../images/squadImg/gigi.jpg'),
    backgroundImg: require('../../images/squadBackgroundImg/gigi.jpg'),
    backgroundStyle: {
      top: '-46%',
      right: '0',
    },
  },
  secondarySponsorsGuys: [
    {
      name: 'Adrian Cayaco',
      desc: '',
      img: require('../../images/squadImg/ade.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/ade.jpg'),
      backgroundStyle: {
        top: '-5%',
        right: '0',
      },
    },
    {
      name: 'Jorge Alfred Tabilin',
      desc: '',
      img: require('../../images/squadImg/jorge.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/jorge.jpg'),
      backgroundStyle: {
        top: '-20%',
        left: '-20%',
      },
    },
    {
      name: 'Hykinel Bon Guarte',
      desc: '',
      img: require('../../images/squadImg/bon.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/bon.jpg'),
      backgroundStyle: {
        top: '-25%',
        left: '0',
      },
    },
  ],
  secondarySponsorsGals: [
    {
      name: 'Ana Maria Agnasin',
      desc: '',
      img: require('../../images/squadImg/ana.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/ana.jpg'),
      backgroundStyle: {
        top: '0',
        left: '-10%',
      },
    },
    {
      name: 'Rica Jerene Maravilla',
      desc: '',
      img: require('../../images/squadImg/rica.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/rica.jpg'),
      backgroundStyle: {
        top: '-15%',
        left: '-10%',
      },
    },
    {
      name: 'Aljeri Agnasin',
      desc: '',
      img: require('../../images/squadImg/aj.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/aj.jpg'),
      backgroundStyle: {
        bottom: '0',
        left: '-35%',
      },
    },
  ],
  groomsmen: [
    {
      name: 'John Eddie Ayson',
      desc: '',
      img: require('../../images/squadImg/je.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/je.jpg'),
      backgroundStyle: {
        top: '0',
        left: '-25%',
      },
    },
    {
      name: 'Patrick Vincent Bamba',
      desc: '',
      img: require('../../images/squadImg/bamba.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/bamba.jpg'),
      backgroundStyle: {
        bottom: '-23%',
        left: '-25%',
      },
    },
    {
      name: 'Lyndon Jason Catalan',
      desc: '',
      img: require('../../images/squadImg/jason.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/jason.jpg'),
      backgroundStyle: {
        top: '-14%',
        left: '-3%',
      },
    },
    {
      name: 'Arman Rabal',
      desc: '',
      img: require('../../images/squadImg/arman.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/arman.jpg'),
      backgroundStyle: {
        top: '-7%',
        right: '-7%',
      },
    },
  ],
  bridesmaids: [
    {
      name: 'Francesca Amoroso',
      desc: '',
      img: require('../../images/squadImg/chesca.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/chesca.jpg'),
      backgroundStyle: {
        bottom: '-75%',
        left: '0',
      },
    },
    {
      name: 'Karmela Francia',
      desc: '',
      img: require('../../images/squadImg/melai.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/melai.jpg'),
      backgroundStyle: {
        top: '-17%',
        left: '-30%',
      },
    },
    {
      name: 'Kiel Gonzales',
      desc: '',
      img: require('../../images/squadImg/kiel.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/kiel.jpg'),
      backgroundStyle: {
        top: '-20%',
        left: '-20%',
      },
    },
    {
      name: 'Kyra Ysobel Flores',
      desc: '',
      img: require('../../images/squadImg/kyra.jpg'),
      backgroundImg: require('../../images/squadBackgroundImg/kyra.jpg'),
      backgroundStyle: {
        top: '-3%',
        left: '-18%',
      },
    },
  ],
  bearers: [
    { name: 'Anthony Louis Belaong' },
    { name: 'Alec Rhys Calalang' },
    { name: 'Lara Julianne Maravilla' },
    { name: 'Marceline Jean Tabilin' },
  ],
};

const defaultDesc = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque in tortor a arcu luctus elementum. Curabitur diam sapien, dictum nec felis ac, iaculis laoreet ligula. Morbi auctor metus vitae enim pellentesque, vitae cursus dui ultrices. Maecenas bibendum cursus gravida. Suspendisse volutpat at neque sed consectetur. Nam et vestibulum enim. Aenean.';
const getDesc = desc => (desc && desc.length > 0 ? desc : defaultDesc);
const getShortDesc = desc => `${desc.split(' ').slice(0, 8).join(' ')}…`;

export default Object
  .keys(data)
  .reduce((obj, k) => {
    const squad = data[k];
    if (squad.map) {
      return {
        ...obj,
        [k]: squad.map((o) => {
          const desc = getDesc(o.desc);
          return {
            ...o,
            desc,
            shortDesc: getShortDesc(desc),
          };
        }),
      };
    }

    const desc = getDesc(squad.desc);
    return {
      ...obj,
      [k]: {
        ...squad,
        desc,
        shortDesc: getShortDesc(desc),
      },
    };
  }, {});



// WEBPACK FOOTER //
// ./src/components/SquadPage/data.js